var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"gc-popup__button-close"},_vm.$listeners),[_c('icon-backward',{attrs:{"size":"md1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }